// @flow
import React, { createContext } from "react";

const UploaderContext = createContext<Object>(null);

export const getComponentConsumer = (Component: any) => (props: Object) => <UploaderContext.Consumer>
	{(uploader: Object) => <Component {...props} uploader={uploader}/>}
</UploaderContext.Consumer>;

export default UploaderContext;
